module.exports = __webpack_public_path__ + "static/media/defaultIcon.73a0bc1f.png";